import forEach from '@Utils/forEach'

export default class LoginLink {
  constructor () {
    forEach(document.querySelectorAll('[data-role="login-link"]'), (i, el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        App.dispatcher.fire('user-login.open')
      })
    })
  }
}
